var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"filter--search__value"},[_c('div',{staticClass:"checkbox-with-label"},[_c('span',{staticClass:"checkbox-with-label__checkbox--black",class:{ active: _vm.isChecked },on:{"click":_vm.applyFilter}}),_vm._v(" "),_c('small',{staticClass:"checkbox-with-label__text",domProps:{"textContent":_vm._s(_vm.filterOption)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }